module.exports = __webpack_public_path__ + "static/media/trips-icon.0ebe90ff.svg";